import * as utils from "./_utils.js";
export default class EventHandler {
	constructor(store, log, isPrivate){
        this.log = log;
        this.isPrivate = isPrivate;
        this.messageHandlers = {};
        this.handler = utils.handler.bind(this);
        this.subscribe = utils.subscribe.bind(this);
        this.unsubscribe = utils.unsubscribe.bind(this);
        this.has = (name, handler) => {
          if (!this.messageHandlers[name]) {
              return false;
          }
          
          return this.messageHandlers[name].indexOf(handler) !== -1;
        }

        store.subscribe(()=>{
            const state = store.getState();
            const [resource, event] = state.action.split('.');
            
            let eventData;
            let eventName = resource;
            if(resource !== 'shapes'){
                switch(event){
                    case "hydrate": eventName = `shapes.${resource}.ready`; break;
                    case "load": eventName = `shapes.${resource}.load`; break;
                    default: eventName = `shapes.${resource}.update`
                }
                eventData = state[resource];
            }

            this.handler(eventName, eventData);
            this.handler('shapes.update', state);
        });
    }   
}